import React from 'react';
import EsAlignmentTable from './subComponents/EsAlignmentTable.component';
import EsAlignmentHistoricalChart from './subComponents/EsAlignmentHistoricalChart.component';
import { NoHistoricalDataMessage } from '../../../feedback/NoDataMessage.component';
import { FundInfoComponentProps } from '../../../layout/general/SimpleGeneralPageWrapper';
import { useEsAlignmentData } from './services/queries';
import { useFundEsgTimeSeriesData } from '../../../../api/rs-hg/esg';
import { QueryBoundary } from '../../../utilityComponents/QueryBoundary';

export interface EsAlignmentUnderlyingTableData {
  exposure_percentage: number;
  gmid: number;
  gross_exposure_percentage: number;
  isin: string;
  position_id: string;
  position_name: string;
  absolute_exposure: number;
}

export interface EsAlignmentTableData {
  description: string;
  indicator: string;
  indicator_name: string;
  limit: number;
  limit_type: string;
  pass_fail: string;
  value: number;
  unit: string;
  underlying: EsAlignmentUnderlyingTableData[];
  absolute_value: number;
}

const EsAlignmentMonitor: React.FC<FundInfoComponentProps> = ({
  fundId,
  positionDate,
}) => {
  const esAlignmentQuery = useEsAlignmentData(fundId, positionDate);
  const fundEsgTimeSeriesQuery = useFundEsgTimeSeriesData(fundId, positionDate);

  const description = 'Historical E/S alignment data is not available for this fund at the selected date. Please try selecting a different date or check back later.';

  return (
    <div className="flex flex-col min-h-[calc(100vh-10.00rem)] overflow-auto w-full p-4 gap-4">
      <div className="flex-1 flex items-center justify-center">
        <QueryBoundary
          isLoading={esAlignmentQuery.isLoading}
          isError={esAlignmentQuery.isError}
          data={esAlignmentQuery.data}
          loadingMessages={['Loading E/S Alignment Data']}
          errorMessage="No Data Available."
          noDataMessage="No Data Available."
          card
        >
          {(data) => <EsAlignmentTable data={data} />}
        </QueryBoundary>
      </div>
      <div className="flex-1 flex items-center justify-center">
        <QueryBoundary
          isLoading={fundEsgTimeSeriesQuery.isLoading}
          isError={fundEsgTimeSeriesQuery.isError}
          data={fundEsgTimeSeriesQuery.data}
          loadingMessages={['Loading Historical E/S Data']}
          errorComponent={<NoHistoricalDataMessage description={description} />}
          noDataComponent={<NoHistoricalDataMessage description={description} />}
          card
        >
          {(data) => <EsAlignmentHistoricalChart data={data} />}
        </QueryBoundary>
      </div>
    </div>
  );
};

export default EsAlignmentMonitor;
